export default __webpack_public_path__ + "static/media/twitter.d8203e37.svg";